/**
 * AppFooter — persistent Privacy / Terms links at the bottom of every page.
 * Targets are static files in web/public/ served at the site root (no auth),
 * open in a new tab. Filenames match what's deployed (no hyphens).
 */
// F513 (Pete, 2026-10-10): "Keep those visible on the bardotek pages, not the symbia ones".
// A BUILD setting: only the Bardotek replica's build sets VITE_SHOW_LEGAL_LINKS=true (its pages
// carry Bardotek Software, Inc.'s full wording). Production's web\.env.local does not set it, so
// Symbia hides the links - its pages read TBD and stay reachable by URL only, because the
// toll-free SMS application (+1 866-226-4008) cites them.
const SHOW_LEGAL_LINKS: boolean = import.meta.env.VITE_SHOW_LEGAL_LINKS === 'true';

export default function AppFooter() {
    if (!SHOW_LEGAL_LINKS) return null;
    const link = "text-muted-foreground hover:text-foreground underline underline-offset-2 transition-colors";
    return (
        <footer className="shrink-0 w-full py-3 px-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs text-muted-foreground border-t border-black/5">
            <a className={link} href="/privacypolicy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            <span aria-hidden="true">·</span>
            <a className={link} href="/termsandconditions.html" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a>
        </footer>
    );
}